import { render, staticRenderFns } from "./ProfileOrders.vue?vue&type=template&id=3bac2f68&scoped=true&"
import script from "./ProfileOrders.vue?vue&type=script&lang=js&"
export * from "./ProfileOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOrders.vue?vue&type=style&index=0&id=3bac2f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac2f68",
  null
  
)

export default component.exports